
(() => {
  class CountdownTimer {
    constructor(endDate, timezone, element, timerEndLabel) {
      this.endDate = new Date(endDate);
      this.timezone = timezone;
      this.element = element;
      this.timerEndLabel = timerEndLabel || 'Promotion Ended';
      this.timer = null;
      this.startCountdown();
    }

    calculateTimeRemaining() {
      const now = new Date().toLocaleString('en-US', { timeZone: this.timezone });
      const diff = this.endDate - new Date(now);

      if (Number.isNaN(diff) || diff <= 0) {
        return null;
      }

      return {
        daysRaw: Math.floor(diff / (1000 * 60 * 60 * 24)),
        days: this.twoPlaces(Math.floor(diff / (1000 * 60 * 60 * 24))),
        hours: this.twoPlaces(Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))),
        minutes: this.twoPlaces(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))),
        seconds: this.twoPlaces(Math.floor((diff % (1000 * 60)) / 1000))
      };
    }

    twoPlaces(number) {
      return number < 10 ? `0${number}` : `${number}`;
    }

    render(timeRemaining) {
      // Rule: hide the DAY unit once there is less than one full day left
      const dayBlock = timeRemaining.daysRaw > 0
        ? `<div class="countdown_count days"> <span class="counter"> ${timeRemaining.days} </span> <span class="counter-label"> DAY </span> </div>`
        : '';
      this.element.innerHTML = `
        ${dayBlock}
        <div class="countdown_count hours"> <span class="counter"> ${timeRemaining.hours} </span> <span class="counter-label"> HR </span> </div>
        <div class="countdown_count minutes"> <span class="counter"> ${timeRemaining.minutes}  </span> <span class="counter-label"> MIN </span> </div>
        <div class="countdown_count seconds"> <span class="counter"> ${timeRemaining.seconds} </span>  <span class="counter-label"> SEC </span> </div>
      `;
    }

    showEnded() {
      clearInterval(this.timer);
      this.element.innerHTML = this.timerEndLabel;
    }

    startCountdown() {
      const update = () => {
        const timeRemaining = this.calculateTimeRemaining();

        if (!timeRemaining) {
          this.showEnded();
          return false;
        }

        this.render(timeRemaining);
        return true;
      };

      if (update()) {
        this.timer = setInterval(update, 1000);
      }
    }
  }

  function createCountdownTimer(element) {
    if (element.dataset.countdownInitialized === 'true') {
      return;
    }

    const endYear = element.dataset.end_year;
    const endMonth = element.dataset.end_month;
    const endDay = element.dataset.end_day;
    const endHour = element.dataset.end_hour;

    if (!endYear || !endMonth || !endDay) {
      return;
    }

    const timerEndLabel = element.dataset.timer_bar_timer_end;
    const timezone = element.dataset.timezone || 'Australia/Sydney';
    const endDate = `${endYear}/${endMonth}/${endDay}${endHour ? ` ${endHour}` : ''}`;

    element.dataset.countdownInitialized = 'true';
    new CountdownTimer(endDate, timezone, element, timerEndLabel);
  }

  function initCountdownTimers(root = document) {
    const countdownElements = root.matches && root.matches('.countdown')
      ? [root]
      : Array.from(root.querySelectorAll('.countdown'));

    countdownElements.forEach(createCountdownTimer);
  }

  window.initCountdownTimers = initCountdownTimers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCountdownTimers());
  } else {
    initCountdownTimers();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCountdownTimers(event.target);
  });
})();
